import React from 'react';
import cn from 'classname';
import moment from 'moment';

const OrdinaryRow = (props) => {
	const { row, dates, index, showAllEnabled } = props;

	if (row.can_be_expanded) {
		return <CanBeExpandedRow {...props} />;
	}

	return (
		<tr
			className={cn({ 'row-declined': !!row.is_rejected_prolong, 'modify-background': !!(index % 2) })}
		>
			<td className="id fixed-col width-200 padding-right-30">
				<div>
					<p><span>{row.manager_email}</span></p>
					<p><span>{row.affiliate_email}</span></p>
					<p><span>Affiliate id: ({row.affiliate_id})</span></p>
					<p><span>{row.location_name}</span></p>
					<p><span>{row.offer_name}</span> </p>
					<p><span>{row.traffic_source}</span> </p>
					{ row.campaign_id && <p>Camp id: <span>{row.campaign_id}</span> </p>}
				</div>
			</td>
			<td className="width-100">
				<span>{row.id}</span>
			</td>
			<td className="width-100">
				<p>{row.starts_at}</p>
				<p>{row.ends_at}</p>
				<p>
					<span>{row.duration && Object.values(row.duration)[0]}</span>
					<span> {row.duration && Object.keys(row.duration)[0]}</span>
				</p>
			</td>
			<td className="width-100">
				<span>{Math.round(row.target_percent)}%</span>
			</td>
			<td className="width-100">
				{
					row.payouts && row.payouts.map((item, index) =>
						<p key={index}>
							<span>{Object.values(item)[0]}</span>
							<span> $</span>
						</p>
					)
				}

			</td>
			<td className="width-100">
				{row.start_leads_setting && row.start_leads_setting
					.sort((a, b) => a.start_leads_count < b.start_leads_count ? -1 : 1)
					.map((item, index) =>
						<p key={index}> {item.start_duration}: {item.start_leads_count}</p>
					)}
			</td>
			<td className="width-100">
				<span>{row.sid}</span>
			</td>
			<td className="width-100 hover-pointer" >
				{row.is_in_progress ? 'Действует' : 'Неактивен'}
			</td>
			<td className="border-col"/>
			{
				dates.map((date, index) =>
					<DateCell
						row={row} date={date} key={index} periodSwitch={props.periodSwitch}
						showAllEnabled={showAllEnabled}
					/>
				)
			}
		</tr>
	);
};

const CanBeExpandedRow = ({ row, dates, toggleExpandedItem, expandedIds }) => {
	let sids = row.sids;

	if (sids) {
		sids = sids.length > 3 ? `${sids.slice(0, 3).join(', ')}, ...` : row.sids.join(', ');
	}

	return (
		<tr>
			<td className="id fixed-col width-200 padding-right-30" >
				<div>
					<p><span>{row.manager_email}</span></p>
					<p><span>{row.affiliate_email}</span></p>
					<p><span>Affiliate id: ({row.affiliate_id})</span></p>
					<p><span>{row.location_name}</span></p>
					<p><span>{row.offer_name}</span> </p>
					<p><span>{row.traffic_source}</span> </p>
					{ row.campaign_id && <p>Camp id: <span>{row.campaign_id}</span> </p>}
					<p
						onClick={toggleExpandedItem.bind(null, row.id)}
					>
						<span className={cn({
							'hover-pointer dropdown-icon expand__icon': true,
							'expand__icon--opened': expandedIds.includes(row.id)
						})}/>
					</p>
				</div>
			</td>
			<td className="width-100">
				<span>{row.id}</span>
			</td>
			<td className="width-100">
				<p>{row.starts_at}</p>
				<p>{row.ends_at}</p>
				<p>
					<span>{row.duration && Object.values(row.duration)[0]}</span>
					<span> {row.duration && Object.keys(row.duration)[0]}</span>
				</p>
			</td>
			<td className="width-100">
				<span>{Math.round(row.target_percent)}%</span>
			</td>
			<td className="width-100">
				{
					row.payouts && row.payouts.map((item, index) =>
						<p key={index}>
							<span>{Object.values(item)[0]}</span>
							<span>$</span>
						</p>
					)
				}

			</td>
			<td className="width-100">
				{row.start_leads_setting && row.start_leads_setting
					.sort((a, b) => a.start_leads_count < b.start_leads_count ? -1 : 1)
					.map((item, index) =>
						<p key={index}> {item.start_duration}: {item.start_leads_count}</p>
					)}
			</td>
			<td className="width-100">
				<span>{sids || row.sid}</span>
			</td>
			<td className="width-100 hover-pointer" >
				{row.is_in_progress ? 'Действует' : 'Неактивен'}
			</td>
		</tr>
	);
};

const DateCell = props => {

	const { row, date, periodSwitch, showAllEnabled } = props;
	const startDate = moment(date);
	const finalDate = moment(date).add(periodSwitch ? 1 : 7, periodSwitch || 'days');
	let canShow = !!showAllEnabled;
	for (let iterator = startDate; iterator.isBefore(finalDate); iterator = iterator.add(1, 'day')) {
		if (moment(iterator).isBetween(
			moment(row.starts_at, 'YYYY-MM-DD'), moment(row.ends_at, 'YYYY-MM-DD')
		)) {
			canShow = true;
		}
	}

	const approved_count = Number(row[`approved_count_${date}`]) || 0;
	const non_trash_count = Number(row[`non_trash_count_${date}`]) || 0;

	const approveRatio = non_trash_count > 0 ? approved_count / non_trash_count : 0;
	const approvePercent = approveRatio * 100;

	const expectedApproveDiff =
		approved_count - Math.floor(non_trash_count * Number(row.target_percent || 0) / 100);
	const usdPayout = row.payouts && row.payouts.length
		? row.payouts.filter(r => r['usd'] > 0)[0].usd
		: 0;

	return (
		<td className={cn({'date-col': true, 'gray-background': !canShow})}>
			{
				canShow &&
				<p>
					<span className="sub-col">{non_trash_count}</span>
					<span className="sub-col">{Math.round(approvePercent)}</span>
					<span className="sub-col">
						{Math.round(approvePercent - row.target_percent)} %
					</span>
					<span className="sub-col">{Math.round(expectedApproveDiff * usdPayout)}</span>
				</p>
			}
		</td>
	);
};

export default OrdinaryRow;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/garant-forecast/components/table/row.js